<template>
  <div class="collapse-item">
    <div class="collapse-item-head">
      <slot name="title"> 
         <svg-icon
                :icon-class=" title == '员工数据' ? 'rendui':'' || title == '合同数据' ? 'wenjianwujiaoxing' : ''"
                style="font-size: 14px;margin-left:2px"></svg-icon>
        {{ title }}</slot>
      <el-switch
        v-model="item.switched"
        active-color="#6669e3"
        inactive-color="#b8b8c4"
        @change="switchChange"
        :style="{
          paddingLeft: '35px',
          position: 'absolute',
          left: '160px',
          top: '8px',
        }"
      >
      </el-switch>
      <span
        class="collapse-item-head_arrow"
        @click="handClick"
        v-if="item.views.length > 0"
      >
        {{ isActive ? "收起" : "展开" }}
        <i :class="{ 'arrow-up': isActive, 'arrow-down': !isActive }"></i>
      </span>
    </div>
    <transition>
      <div class="collapse-item-body" v-show="isActive">
        <div
          class="collapse-content"
          :style="{ 'padding-bottom': item.views.length > 0 ? '25px' : '0px' }"
        >
          <slot :row="item"> </slot>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  name: "SsgCollapse",
  data() {
    return {
      isActive: this.item.switched,
      value: true,
    };
  },
  props: {
    title: String,
    item: Object,
  },
  methods: {
    handClick() {
      this.conentSwitch(this.isActive);
    },
    switchChange(val) {
      this.$emit("headSwitch", val);
      if (val) {
        this.isActive = true;
      } else {
        this.isActive = false;
      }
    },
    conentSwitch(b) {
      if (b) {
        this.isActive = false;
      } else {
        this.isActive = true;
      }
    },
  },
};
</script>
<style  scoped>
.collapse-item {
  border: 1px solid #c6c7ff;
  margin-bottom: 12px;
  font-size: 12px;
}
.collapse-item-head {
  cursor: pointer;
  height: 40px;
  background-color: #f2f3ff;
  text-align: left;
  padding-left: 10px;
  line-height: 40px;
  color: #303140;
  font-weight: bold;
  position: relative;
  font-size: 14px;
}
.collapse-item-head_arrow {
  float: right;
  line-height: 40px;
  margin-right: 10px;
  display: block;
  width: 40px;
  position: relative;
  font-size: 12px;
  font-weight: 400;
  color: #6669E3;
}
.collapse-content {
  font-weight: 700;
  font-size: 12px;
}
.arrow-up {
  background-image: url("../../../assets/img/open_list.png");
  background-repeat: round;
  display: block;
  width: 10px;
  height: 10px;
  position: absolute;
  top: 15px;
  right: 4px;
}
.arrow-down {
  background-image: url("../../../assets/img/close_list.png");
  background-repeat: round;
  display: block;
  width: 10px;
  height: 10px;
  position: absolute;
  top: 15px;
  right: 4px;
}
.collapse-item-head /deep/ .el-switch__core {
  width: 36px !important;
  height: 20px !important;
}
.collapse-item-head /deep/ .el-switch__core::after {
  width: 16px !important;
  height: 16px !important;
}
.collapse-item-head /deep/.el-switch.is-checked .el-switch__core::after {
  left: 100%;
  margin-left: -17px !important;
}
.collapse-content /deep/ .el-switch__core {
  width: 28px !important;
  height: 16px !important;
}
.collapse-content /deep/ .el-switch__core::after {
  width: 12px !important;
  height: 12px !important;
}
.collapse-content /deep/.el-switch.is-checked .el-switch__core::after {
  left: 100%;
  margin-left: -13px !important;
}
.collapse-item-body /deep/ .module_name {
  color: #545566;
  font-weight: bold;
}
</style>

